export default __webpack_public_path__ + "static/assets/4a2ce7f91157e3155ee7ad3a93d7bd7e.png";